<template>
   <div>
        <div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">Handsets and accessories</div>
                    <div data-width='15%' class="font light-gray">56,394</div>
                    <div data-width='15%' class="font">53,545</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Provision for obsolescence</div>
                    <div data-width='15%' class="font light-gray">(5,292)</div>
                    <div data-width='15%' class="font">(5,032)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">51,102</div>
                    <div data-width='15%' class=" bold white">48,513</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">أجهزة هواتف ومكملاتها</div>
                    <div data-width='15%' class="font light-gray">56,394</div>
                    <div data-width='15%' class="font">53,545</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">مخصص تقادم المخزون</div>
                    <div data-width='15%' class="font light-gray">(5,292)</div>
                    <div data-width='15%' class="font">(5,032)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">51,102</div>
                    <div data-width='15%' class=" bold white">48,513</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>